module.exports = __webpack_public_path__ + "static/media/layout_single.251a6d8f.svg";